// extracted by mini-css-extract-plugin
export default {"ActiveFundsWidget":"iYTbO","ActiveFunds":"MR6CF"};